module.exports = __webpack_public_path__ + "img/upload.cbf44203.svg";